import React, { useEffect, useState } from "react";
import { MajorColumns } from "./column";
import BlankPage from "./blank";
import MyLoader from "../../component/loader";
import useFetchData from "../../hooks/useFetchData";
import DataTable from "../../component/table";
import RightDrawer from "../../layout/appLayout/rightDrawer";
import { useDrawer } from "../../hooks/useDrawer";
import { DateFilter, StatusFilter } from "../../component/filters";
import { ActionIcon } from "rizzui/action-icon";
import { Text } from "rizzui/typography";
import CallDrawer from "../../component/callDrawer";

export default function Calls() {
  useEffect(() => {
    document.title = "Calls";
  }, []);
  const [page, setPage] = useState(1);
  const { data, error, isLoading, loading } = useFetchData({
    dataType: "calls",
    page: page,
  });
  const [filters, setFilters] = useState<{
    status?: string;
    dates?: [Date | null, Date | null];
  }>({});

  const { openDrawer, closeDrawer } = useDrawer();

  if (loading) return <MyLoader />;
  else
    return data?.data?.length > 0 ? (
      <div className="w-full">
        <div className="flex flex-wrap justify-end mb-[32px] gap-[12px] w-full">
          <div className="h-[35px] w-[162px]">
            <DateFilter
              /* handleChange={(updatedFilters) =>
                setFilters((prev) => ({ ...prev, ...updatedFilters }))
              } */
              handleChange={setFilters}
              value={filters?.dates}
            />
          </div>
          <div className="w-[162px]">
            <StatusFilter
              /* handleChange={(updatedFilters) =>
                setFilters((prev) => ({ ...prev, ...updatedFilters }))
              } */
              handleChange={setFilters}
              page="calls"
              value={filters?.status}
            />
          </div>
          <div className="md:hidden basis-full" />
          <ActionIcon
            className="p-0 m-0 !bg-btn w-[128px] h-[35px] rounded-[4px]"
            onClick={() => console.log(filters)}
          >
            <Text className="font-[500] text-background text-[14px] font-switzer">
              Apply Filter
            </Text>
          </ActionIcon>

          {Object.keys(filters).length > 0 &&
            filters.constructor === Object && (
              <ActionIcon
                className="p-0 m-0 !bg-transparent w-fit h-[35px] rounded-[4px]"
                onClick={() => setFilters({})}
              >
                <Text className="font-[400] text-[#E63946] text-[13px] font-outfitRegular">
                  Clear all filters
                </Text>
              </ActionIcon>
            )}
        </div>
        <DataTable
          data={data?.data ?? []}
          isLoading={isLoading}
          columns={MajorColumns()}
          error={error}
          pageSize={data?.metadata?.pagination?.totalPages}
          setPage={setPage}
          meta={(row) => {
            openDrawer({
              view: <CallDrawer row={row} />,
              placement: "right",
              containerClassName: "w-full md:!w-[435px]",
            });
          }}
          defaultSort={{ id: "dateTime", desc: true }}
        />
      </div>
    ) : (
      <BlankPage />
    );
}
